import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import Config from 'config';
import QuestionResultsCollection from './QuestionResultsCollection';

var PollResults = Backbone.Model.extend({

    url: function() {
        var base = '/api/v2/polls/' + this.get('pollId') + '/wallResults?';
        if (this.query) {
            var attributes = this.query.get('attribute');
            base += attributes.map(function(attribute) {
                var category = encodeURIComponent(attribute.get('category'));
                var id = encodeURIComponent(attribute.get('id'));
                return 'attribute=' + category + ':' + id;
            }).join('&');
        }
        return base;
    },

    initialize: function() {
        _.bindAll(this, 'handleSocketPollResults');
        this.set('questions', new QuestionResultsCollection(this.get('questions')));
        this.openSocket();
    },

    openSocket: function() {
        if (this.get('pollId') && !this.emittedCoockie) {
            this.emittedCoockie = true;
            Backbone.trigger('socketEmit', 'pollId', this.get('pollId'));
            Backbone.trigger('socketOn', 'pollResults', this.handleSocketPollResults);
        }
    },

    handleSocketPollResults: function(payload) {
        var data = _.isObject(payload) ? payload : $.parseJSON(payload);
        if (_.isEmpty(data) || this.get('organizer')) {
            this.fetch();
        } else if (data.pollId === this.get('pollId')) {
            this.get('questions').set(data.questions);
        }
    },

    parse: function(response) {
        var questions = this.get('questions');
        questions.set(response.questions);
        response.questions = questions;
        response.facets = response.facets || {};
        return response;
    },

    setQuery: function(query) {
        this.query = query;
        var fetchWithoutParams = function() {
            this.fetch();
        };
        this.listenTo(this.query.get('attribute'), 'add remove reset', fetchWithoutParams);
    }

});

export default PollResults;

